import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { DefaultUser } from '@/components/icons/icons';
import globalStore from '@/stores/store';

import styles from './styles.module.less';

const NotLogin = () => {
  const {
    initialAwardconfig: { mobilereg }
  } = globalStore;
  return (
    <Link to="/login">
      <div className={styles.box}>
        <div className={styles.left}>
          Free Bonus <span>$ {mobilereg}</span>
        </div>
        <div className={styles.btn}>
          <DefaultUser className={styles.user} />
          <span>Connect</span>
        </div>
      </div>
    </Link>
  );
};

export default observer(NotLogin);
